<template>
    <div>
        <van-overlay :show="showLoading">
            <div style="width: 100%;height: 100%;;display: flex;align-items: center;justify-content: center;">
                <van-loading size="24px" v-if="showLoading">加载中...</van-loading>
            </div>

        </van-overlay>
        <div class="treat_main_list">
            <van-radio-group v-model="checked">
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-if="list.length > 0"
                    :offset="30" :immediate-check="false" @load="onLoad">
                    <div class="one" v-for="(item, index) in list" :key="index"
                        @click="sendDataToParent(item.id)">

                        <div class="name_appointment">
                            <div class="left text-overflow">{{ item.username }}</div>
                            <div>
                                <div class="right ">
                                    <div class="detail_info" style="width: 4.5rem">
                                        <span>{{ item.createtime }}  ＞</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="title_top">
                          <van-image
                              height="3rem"
                              fit="cover"
                              :src="item.url"
                              :v-lazy="item.url"
                          />
                        </div>
                    </div>
                </van-list>

                <div class="has_no_data" v-else>
                    当前无工作台检验单数据
                </div>
            </van-radio-group>
        </div>
    </div>
</template>
<script>
import {wxtriagecustomerqry, wxnoappointmentcustomerinfoqry, aireporthistory} from '@/api/medical'
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters([
            'username', 'dispname', 'clinicid', 'isrefresh'
        ]),
    },
    props: ['offset', 'planid','qrytype','p_clinicid','p_checked', 'noButton'],
    data() {
        return {
            keyword: '',
            list: [],
            finished: false,
            loading: false,
            page: 0,
            showLoading: true,
            checked: ''
        }
    },
    created() {
        this.$store.dispatch('hideOrShowNav', false)
        this.keyword = ''
        this.onLoad()
    },

    activated() {

        this.$store.dispatch('hideOrShowNav', false)

        if ((this.isrefresh == '1' && !this.loading)||this.planid) {
            this.$store.dispatch('changeIsRefresh', '0')
            this.page = 0
            this.list = []
            this.keyword = ''
            this.finished = false
            this.loading = false
            this.onLoad()
        }
    },
    methods: {
        onLoad() {
            this.loading = true
            this.showLoading = true
            this.page += 1
            let data = {
                page: this.page
            }
            aireporthistory(data).then(response => {
              this.loading = false
              this.showLoading = false
              this.checked = this.p_checked

              if (response.response_body.num > 0) {
                this.list = [...this.list, ...response.response_body.list] || []
                console.log("list===",this.list);
                if (this.page >= response.response_body.pages) {

                  this.finished = true
                }
              } else {
                this.finished = true
                this.list = []
              }

            }).catch(error => {
              this.loading = false
              this.showLoading = false
            })
        },
        sendDataToParent(id) {
          console.log("进入方法")
          this.$router.push({
            path: '/aiIdentify',
            query: {
              questionid:id,
            }
          })
        },
    }
}
</script>
<style lang="scss" scoped>
.treat_main_list {
    background-color: #fff;

    .one {
        background: linear-gradient(180deg, rgba(207, 140, 87, 0.2) 0%, rgba(255, 249, 244, 0) 20%) !important;
    }

    .text {
        margin: 10px 0;
        line-height: 22px;
        text-align: left;

        span {
            margin-right: 10px;
        }
    }

    .title_top {
        .right {
            display: flex;
            align-items: center;
            justify-content: flex-end;

            .name {
                width: 100px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .name_appointment {
        .left {
            width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .diagnoseButton {
        margin: 0 auto;
        width: 120px;
        margin-top: 15px;
    }
}

.btnimg {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 10px;
    bottom: 200px;

    img {
        width: 100%;
        height: 100%;
    }
}

.page_top .search_div {
    width: 100%;
}

.van-search__content {
    padding-left: unset;
}

.keyword_input {
    width: 100%;
}

:deep .van-radio {
    display: none;
}

.text-overflow {
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏超出的内容 */
    text-overflow: ellipsis;
    /* 用省略号表示被隐藏的部分 */
    max-width: 200px;
    /* 设置最大宽度以限制文本的显示长度 */
}</style>
